








import { Component, Vue, Prop } from 'vue-property-decorator';

import { upperCaseFirstLetter } from '@/utils/string';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

export enum EStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  ARCHIVED = 'archived',
  PENDING = 'pending',
  FAILED = 'failed',
  PARTIALLY_ACTIVE = 'partially-active',
  INACTIVE = 'inactive',
  ACTION_NEEDED = 'action-needed',
  COIN_NETWORK = 'coin-network'
}

const textMapper: Record<string, string> = {
  [EStatus.COIN_NETWORK]: 'Coin Network'
};

@Component({
  components: {
    Typography
  }
})
export default class StatusTag extends Vue {
  @Prop({ default: EStatus.ACTIVE })
  status!: EStatus;
  @Prop(String) sufix!: string;

  get tagText(): EStatus {
    return this.status.toLowerCase() as EStatus;
  }

  get textStatus() {
    const text = this.tagText;
    if (textMapper[text]) return textMapper[text];

    return upperCaseFirstLetter(text.replace('-', ' '));
  }
}
